import { PricingRowDto } from "../../state/pricing/PricingRow"
import { Row } from "../../state/rows/Row"
import { PRODUCT_TYPE } from "../../state/product/Types"

export const isBundleItem = (item: PricingRowDto | Row | undefined):boolean => {
    return item?.attributes?.parentId !== ""
}

export const isBundle = (item: Row): boolean => {
    return item.attributes.itemObject.attributes.type === PRODUCT_TYPE.BUNDLE
}


// WEBPACK FOOTER //
// ./src/utils/pricing/utils.ts